import React from "react";
import Video from "./Video";
import "../css/homepage-sections.css";

export default function Offers() {
  return (
    <>
      <div className="professional-video-section">
        <div className="container-fluid py-5">
          {/* Professional Section Header */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <div className="professional-section-badge">
                <i className="fas fa-play-circle mr-2"></i>
                Experience NT Sticks
              </div>
              <h2 className="professional-section-title">
                Witness the Art of 
                <span className="gradient-text"> Sacred Fragrance Creation</span>
              </h2>
              <p className="professional-section-subtitle">
                Take a journey behind the scenes and discover how our premium incense sticks are crafted with love, tradition, and the finest natural ingredients.
              </p>
            </div>
          </div>

          {/* Video Content */}
          <div className="row px-xl-5 justify-content-center">
            <div className="col-lg-10">
              <div className="professional-video-container">
                <div className="video-wrapper">
                  {/* <div className="video-overlay">
                    <div className="play-button-overlay">
                      <i className="fas fa-play"></i>
                    </div>
                  </div> */}
                  <Video 
                    className="professional-video" 
                    url="../../assets/nt/ntvideo.mp4" 
                    poster="../../assets/nt/ganesh12.jpg"
                    width="100%" 
                    height="100%"
                  />
                </div>
                
                <div className="video-info-section">
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <h4 className="video-title">
                        <i className="fas fa-leaf mr-2 text-success"></i>
                        The NT Sticks Story: From Nature to Your Home
                      </h4>
                      <p className="video-description">
                        Discover the meticulous process behind our handcrafted incense sticks, from selecting the finest natural ingredients to the traditional techniques passed down through generations.
                      </p>
                    </div>
                    {/* <div className="col-md-4 text-center">
                      <div className="video-stats">
                        <div className="stat-item">
                          <i className="fas fa-eye"></i>
                          <span>10K+ Views</span>
                        </div>
                        <div className="stat-item">
                          <i className="fas fa-heart"></i>
                          <span>500+ Likes</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* YouTube Video Section */}
          <div className="row px-xl-5 justify-content-center mt-5">
            <div className="col-lg-8">
              <div className="youtube-video-section">
                <div className="youtube-header">
                  <div className="youtube-badge">
                    <i className="fab fa-youtube mr-2"></i>
                    Featured on YouTube
                  </div>
                  <h4 className="youtube-title">Complete Manufacturing Process</h4>
                  <p className="youtube-subtitle">Watch our detailed documentary showcasing the complete journey of NT Sticks creation</p>
                </div>
                
                <div className="youtube-video-wrapper">
                  <Video 
                    className="youtube-professional-video" 
                    url="https://youtu.be/Lo4bwSwLizA" 
                    width="100%" 
                    height="100%"
                  />
                  <div className="video-recommendation">
                    <i className="fas fa-expand-arrows-alt mr-2"></i>
                    <span>Best viewed in full screen for optimal experience</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="row justify-content-center mt-5">
            <div className="col-lg-6 text-center">
              <div className="video-cta-section">
                <h4 className="cta-title">Ready to Experience Premium Quality?</h4>
                <p className="cta-subtitle">Bring the sacred fragrance of NT Sticks into your home and transform your daily rituals.</p>
                <div className="cta-buttons">
                  <button className="professional-cta-btn primary">
                    <i className="fas fa-shopping-cart mr-2"></i>
                    Shop Now
                  </button>
                  <button className="professional-cta-btn secondary">
                    <i className="fas fa-phone mr-2"></i>
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
